import Vue from 'vue'
import auth from '@/core/auth'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
// import SentryRRWeb from '@sentry/rrweb'

export default function (router) {
  window.Sentry = Sentry

  Sentry.init({
    Vue,
    dsn: 'https://eb969d871ce743da8ed21ea8bad836d5@o250665.ingest.sentry.io/1435895',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })/* ,
      new SentryRRWeb({}) */
    ],
    attachProps: true,
    tracing: true,
    tracesSampleRate: 0.2, // for development, lower is better I guess
    tracingOptions: {
      trackComponents: true
    },
    sendDefaultPii: true,
    normalizeMaxBreadth: 5000,
    maxValueLength: 512,
    maxBreadcrumbs: 200
    // release: 'front-end@2.0.0' // we'd need to update it on every frontend push, but we don't, so better uncomment it
  })

  Vue.config.errorHandler = function (err) {
    Sentry.withScope(scope => {
      if (auth && auth.user) {
        scope.setUser(auth.user)
      }
      Sentry.captureException(err)
    })
    throw err
  }
}
